<template>
    <v-container flex grid-list-lg>
        <template v-if="!smartLock">
            <smart-lock-message></smart-lock-message>
        </template>
        <template v-else>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-toolbar color="#eee" class="elevation-0 secondary--text">
                        <v-toolbar-title>Notificar Usuários</v-toolbar-title>
                    </v-toolbar>
                </v-flex>
            </v-layout>
            <v-card>
                <v-card-text>
                    <v-text-field
                        v-model="notification.title"
                        label="Título"
                        full-width
                        persistent-hint
                        required
                        maxlength="100"
                        :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                    />
                    <v-divider></v-divider>
                    <v-textarea
                        v-model="notification.message"
                        label="Mensagem"
                        counter
                        maxlength="1024"
                        full-width
                        single-line
                        required
                        :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                    />

                    <v-divider></v-divider>

                    <v-col v-if="notification.group" class="d-flex" cols="12" sm="6" style="margin-top: 10px;">
                    <!-- Interface preparada para mandar para grupos de usuários. para habilitar essa função
                        remover v-if acima e esse comentário e inserir em notification o campo group
                    -->
                        <v-select
                        :items="selectItems"
                        label="Para quem?"
                        solo
                        v-model="notification.group"
                        required
                        :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                        />
                    </v-col>

                </v-card-text>
                <v-card-actions>
                    <v-layout row wrap align-center justify-end style="padding: 10px;">
                        <v-btn flat icon color="primary" @click="notificationPush"><v-icon>send</v-icon></v-btn>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </template>
        <v-snackbar
            v-model="snackbar.active"
            :color="snackbar.color"
            :multi-line="snackbar.multiLine"
            :timeout="snackbar.timeout"
            :vertical="snackbar.vertical"
        >
            {{ snackbar.text }}
            <v-btn flat @click="snackbar.active = false">Fechar</v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>

import SmartLockMessage from '@/components/SmartLockMessage'
export default {
    components: { SmartLockMessage },
    data () {
        return {
            snackbar: {
                active: false,
                color: '',
                multiLine: true,
                timeout: 6000,
                vertical: true,
                text: ''
            },
            selectItems: [
                'Todos',
                'Frentistas',
                'Postos',
                'Clientes',
                'Empresas'
            ],
            notification: {
                message: '',
                title: ''
            }
        }
    },
    computed: {
        smartLock () {
            return this.$store.getters.smartLock
        }
    },
    methods: {
        limparCampos () {
            this.notification.message = ''
            this.notification.title = ''
        },
        notificationPush () {
            if (this.notification.message !== '' && this.notification.title !== '') {
                this.$store.dispatch('notificacaoPush', this.notification).then(() => {
                    this.limparCampos()
                    this.snackbar.color = 'info'
                    this.snackbar.text = 'Notificação enviada com sucesso'
                    this.snackbar.active = true
                }).catch(error => {
                    this.snackbar.color = 'error'
                    this.snackbar.text = error
                    this.snackbar.active = true
                })
            } else {
                this.snackbar.color = 'error'
                this.snackbar.text = 'Notificação não enviada. Os campos título e mensagem devem ser preenchidos'
                this.snackbar.active = true
            }
        }
    }
}
</script>
